{
    "locale": "en-US",
    "General": {
        "OrText": "Or",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Go to My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Create new account",
        "ButtonText_SignInToYourAccount": "Sign in to your account",
        "ButtonText_StartInterviewWithoutSigningUp": "Start interview without signing up",
        "ButtonText_StartInterviewWithoutSigningIn": "Start interview without signing in",
        "Navlink_Dashboard": "Dashboard",
        "Navlink_MyInterviews": "My interviews",
        "Navlink_LearnWithHubert": "Learn with Hubert",
        "Navlink_HelpCenter": "Help center",
        "MyProfile": "My profile",
        "LogOut": "Log out"
    },
    "Login": {
        "MainTitle": "View your Hubert interview results",
        "Subtitle": "Sign in to see results, get feedback, read advice, and much more.",
        "LoginTitle": "Sign in to your Hubert account",
        "Label_Email": "Email",
        "Label_Password": "Password",
        "ButtonText_SignIn": "Sign in",
        "ButtonText_ForgotPassword": "Forgot password?",
        "ButtonText_ContinueWithGoogle": "Continue with Google",
        "OrSeparator": "Or",
        "Error_Email_Required": "Email is required.",
        "Error_Email_Invalid": "Enter a valid email.",
        "Error_Password_Required": "Password is required.",
        "Error_Use_Same_Email_As_Interview": "Please use the same email you provided in the interview."
    },
    "Registration": {
        "MainTitle": "View your Hubert interview results",
        "Subtitle": "Sign up to see results, get feedback, read advice, and much more.",
        "RegistrationTitle": "Create Hubert account",
        "BenefitsBox_Title": "You can",
        "BenefitsBox_Point1": "Access your interview history",
        "BenefitsBox_Point2": "Get feedback on your interviews",
        "BenefitsBox_Point3": "Re-use answers in new interviews",
        "BenefitsBox_Point4": "Get interview advice",
        "BenefitsBox_Point5": "Read career guides",
        "BenefitsBox_Point6": "And much more",
        "Label_FirstName": "First name",
        "Label_LastName": "Last name",
        "Label_Email": "Email",
        "Label_Password": "Password",
        "Label_PhoneNumber": "Phone number",
        "Label_TermsOfService": "I accept the",
        "Label_TermsOfServiceLink": "Privacy Policy and Terms & Conditions",
        "Placeholder_CountryCode": "Select country code",
        "Placeholder_PhoneNumber": "E.g. 07700900000",
        "HelpText_Password": "Password should be at least 6 characters long.",
        "ButtonText_SignUp": "Sign up",
        "ButtonText_SignUpWithGoogle": "Sign up with Google",
        "OrSeparator": "Or",
        "Error_FirstName_Required": "First name is required.",
        "Error_LastName_Required": "Last name is required.",
        "Error_Email_Required": "Email is required.",
        "Error_Email_Invalid": "Enter a valid email.",
        "Error_Email_Exists": "Email is already taken.",
        "Error_Password_Required": "Password is required.",
        "Error_Password_6_Characters": "Your password must be at least 6 characters long.",
        "Error_PhoneNumber_Required": "Phone number is required.",
        "Error_PhoneNumber_Invalid": "Phone number is not valid.",
        "Error_PrivacyPolicyCheck_Required": "Privacy Policy and Terms & Conditions must be accepted."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "To take the interview, please accept the terms and conditions for using Hubert. Simply check the box to proceed.",
        "Subtitle_AfterInterviewCompleted": "Sign up to see results, get feedback, read advice, and much more.",
        "PrivacyPolicyText": "By pressing sign up you agree to the",
        "PrivacyPolicyLink": " Privacy Policy and Terms & Conditions",
        "ButtonText_SignUp": "Sign up & go to interview",
        "ButtonText_SignUpNormal": "Sign up",
        "ButtonText_SignInInstead": "Click here to sign in instead"
    },
    "LoginInviteEmail": {
        "Subtitle": "Sign in to see results, get feedback, read advice, and much more."
    },
    "AppMessages": {
        "internal-server-error": "Unexpected error occurred.",
        "invalid-credentials": "Invalid credentials. Please try again.",
        "user-not-found": "Invalid credentials. Please try again.",
        "account-not-found": "Invalid account. Please try again.",
        "verify-email-title": "Verify your email",
        "verify-email-subtitle": "Please check your email to verify your account.",
        "email-not-verified-title": "Email not verified",
        "email-not-verified-subtitle": "Please check your email to verify your account.",
        "verifying-email-title": "Verifying email",
        "verifying-email-subtitle": "Please wait...",
        "sign-in-title": "Signing in",
        "sign-in-subtitle": "Please wait...",
        "server-error": "Something went wrong.",
        "hubert-user-exists": "Account already exists.",
        "account-exists": "Account already exists.",
        "email-verified": "Your email has been verified.",
        "email-is-taken": "Email is already taken.",
        "re-enter-password": "Use your password to sign in",
        "password-reset": "Your password has been changed.",
        "re-enter-new-password": "Use your new password to sign in",
        "invalid-invitation": "Invalid invitation.",
        "invalid-code": "Invalid verification code.",
        "email-already-verified": "Email is already verified.",
        "email-mismatch-title": "Email mismatch",
        "email-mismatch-subtitle": "Please use the same email address you used to apply for the job."
    },
    "TransitionPage": {
        "loading-title": "Loading...",
        "loading-subtitle": "Preparing your data...",
        "logout-title": "Loading...",
        "logout-subtitle": "You are being signed out..."
    },
    "ImpersonationPage": {
        "loading-title": "Loading...",
        "loading-subtitle": "Preparing your data..."
    },
    "ProcessInvitation": {
        "loading-title": "Loading...",
        "loading-subtitle": "Please wait while we load your interview.",
        "InvitationNotFound": "We cannot find your interview.",
        "InvitationExpired": "This link to access the interview has expired.",
        "InvitationExpired_Description1": "Please open the interview from",
        "InvitationExpired_Description2": "or contact your recruiter.",
        "InvitationInvalid": "The link to this invitation is invalid.",
        "InterviewCompleted": "This interview has already been completed."
    },
    "Common": {
        "MyInterviews": {
            "Title": "My interviews",
            "TableHead_Employer": "Employer",
            "TableHead_Job": "Job",
            "TableHead_Status": "Status",
            "TableHead_ApplicationDate": "Application date",
            "TableBody_StartInterview": "The interview is not completed. Click here to start or resume the interview.",
            "TableBody_NotScored": "The interview is completed. Results will be available shortly.",
            "TableBody_Details": "Click here to see interview results and more.",
            "ApplicationDate_Invited": "Invited",
            "ApplicationDate_MinuteAgo": "minute ago",
            "ApplicationDate_MinutesAgo": "minutes ago",
            "ApplicationDate_HourAgo": "hour ago",
            "ApplicationDate_HoursAgo": "hours ago",
            "ApplicationDate_DayAgo": "day ago",
            "ApplicationDate_DaysAgo": "days ago",
            "ButtonText_SeeAllInterviews": "See all interviews",
            "ButtonText_Details": "Details",
            "ButtonText_StartInterview": "Go to interview",
            "ButtonText_NotScored": "Pending results",
            "NoInterviews_Message": "There are no records of previous or upcoming interviews for you."
        },
        "LatestJobPostings": {
            "NoJobPostings": "There are no job postings at the moment. Please check again later."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "My career",
            "Subtitle": "Select an interview to view the assessment and your prospects.",
            "MostRecentInterview": "Most recent interview",
            "ToDo": "To do",
            "NoOngoingInterviews_Title": "No new interview invitations yet.",
            "NoOngoingInterviews_Subtitle": "New Hubert interviews will appear here once scheduled by recruiters.",
            "NoRecentInterviews_Title": "No previous interview records found.",
            "NoRecentInterviews_Subtitle": "Once you are invited to an interview, it will appear below.",
            "ButtonText_StartInterview": "Go to interview",
            "ButtonText_NotScored": "Pending results",
            "ButtonText_Details": "Details"
        },
        "LearnWithHubert": {
            "Title": "Learn with Hubert",
            "Subtitle": "Get advice on how to improve your interview skills and work performance.",
            "PickedForMe": "Latest articles",
            "ButtonText_SeeAllArticles": "See all articles"
        },
        "HubertTip": {
            "Title": "Hubert tip",
            "Subtitle": "Take interviews faster",
            "Description": "Applying for a new job in a similar role that you previously took a Hubert interview for? You can re-use your answers from that previous interview to save time.",
            "ButtonText_ReadMoreTips": "Read more tips"
        },
        "NewCandidateModalPopup": {
            "Title": "You're all set!",
            "DescriptionLine1": "Your account is now ready.",
            "DescriptionLine2": "Manage your interviews and profile. View your results, get feedback, and learn more about how to take interviews.",
            "ButtonText_LetsGo": "Let's go"
        },
        "InterviewCompletedModal": {
            "Title": "Great work!",
            "Subtitle": "You finished your interview.",
            "Description": "Recruiters will review all applications and provide feedback via email or phone as soon as they have an update.",
            "ButtonText_Continue": "Continue"
        },
        "LatestJobPostings": {
            "Title": "Latest job postings",
            "Subtitle": "Explore other offers from Hubert partners that were recently posted."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "My interviews",
        "MyInterviewsSection_Subtitle": "Select an interview to view the assessment and your career opportunities.",
        "MyInterviewsSection_ToDo": "To do"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "See all interviews",
        "InterviewNotFound_Title": "Interview not accessible",
        "InterviewNotFound_Description": "You are trying to access interview details not associated with your account.",
        "ButtonText_GoToAllInterviews": "Go to My interviews",
        "InterviewDetails": {
            "Title": "Interview details",
            "ForRole": "For role",
            "InterviewCompletedOn": "Interview completed on {{date}} at {{time}}"
        },
        "MyResult": {
            "Title": "My result",
            "Subtitle": "Assessed match",
            "ButtonText_LearnMore": "Learn how your answers are assessed",
            "GotPotential_Title": "Strong potential, missing a requirement",
            "GotPotential_Description": "Your answers indicate strong potential for this type of role. However, based on this interview, you may not meet one or more required qualifications for this specific job. This can affect the next steps, depending on the recruiter’s needs and the overall candidate pool. If you aren’t invited to the next stage, please know it doesn’t reflect on your potential as a candidate. Often, it simply comes down to finding a precise fit for the role’s specific needs. Check out other opportunities and improvement tips below.",
            "GotPotential_DescriptionSecondary": "Hubert’s assessment is advisory. The recruiter makes the final decision, and other factors, like the number of candidates, can also affect the outcome.",
            "GreatMatch_Title": "Strong match",
            "GreatMatch_Description": "Your answers aligned well with what recruiters typically look for in this role, and you meet the job requirements. Excellent work. The recruiter will review all candidates and decide next steps.",
            "GreatMatch_DescriptionSecondary": "Hubert’s assessment is advisory. The recruiter makes the final decision, and other factors, like the number of candidates, can also affect the outcome. If you aren’t invited to the next stage, please know it doesn’t reflect on your potential as a candidate. Often, it simply comes down to finding a precise fit for the role’s specific needs. Check out other opportunities and improvement tips below.",
            "OkMatch_Title": "Qualified, add more impact",
            "OkMatch_Description": "You meet the job requirements. To stand out further, your answers may benefit from more clarity and specificity compared with what recruiters typically see for this role. Review your answers below to see where adding a concrete example or outcome can lift your score.",
            "OkMatch_DescriptionSecondary": "Hubert’s assessment is advisory. The recruiter makes the final decision, and other factors, like the number of candidates, can also affect the outcome.",
            "NotClearMatch_Title": "May not be the right fit, yet",
            "NotClearMatch_Description": "Based on this interview, your answers may be less aligned with what the recruiter is looking for in this role, or you may not meet one or more requirements. If you’d like to improve, start with the questions below. Small changes, more specifics, and clear outcomes can make a big difference next time.",
            "NotClearMatch_DescriptionSecondary": "Hubert’s assessment is advisory. The recruiter makes the final decision, and other factors, like the number of candidates, can also affect the outcome."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Professional experiences, motivations, and competencies",
            "QualifyingRequirements": "Qualifying requirements for this specific job",
            "NotQualified_Title": "Room to improve",
            "NotQualified_Description": "Your answers may have been less specific or outcome-focused than the recruiter expects for this role. Look below for areas where adding a concrete example, specific actions, or a clear result can strengthen your response.",
            "GreatResults_Title": "Strong answers",
            "GreatResults_Description": "Your answers indicate you are a good fit for this type of role and communicated clearly. If any question could be improved, you will see it highlighted below.",
            "MeetingRequirements_Title": "Meeting requirements",
            "MeetingRequirements_Description": "Your answers indicate that you meet the qualifying requirements set for this job. This is a good foundation.",
            "NotAllExpectationsMet_Title": "One or more requirements missing",
            "NotAllExpectationsMet_Description": "Based on your answers, you may not meet one or more of the qualifying requirements for this specific job, such as certificates, licenses, education level, or years of experience.",
            "ButtonText_FindOutPossibleReasons": "View details"
        },
        "ScriptFromInterview": {
            "Title": "Read your full interview",
            "ButtonText_SeeWholeTranscript": "Read interview",
            "ButtonText_DeleteInterview": "Delete interview",
            "Loading_Title": "Loading...",
            "Loading_Subtitle": "Please wait while we load your interview transcript."
        },
        "HowToImproveAtInterviews": {
            "Title": "How to improve at interviews",
            "Subtitle_Questions": "Here are some questions where your answer could potentially be improved.",
            "Subtitle_NoQuestions": "No specific answers were flagged. Here are the best ways to add impact for this role.",
            "GreatMatch_Questions_Description": "Even as a strong match, some answers can still be strengthened. If we identified any, you will find them below. Follow the instructions before each question. When describing a situation, include the situation, what you did, and the result. Writing “OK” doesn’t help when we ask you to elaborate. At the same time, avoid overly long answers. Aim for clear and concrete descriptions, like you would in a face-to-face interview.",
            "GreatMatch_NoQuestions_Description": "You performed well on your questions. Excellent work.",
            "OkMatch_Questions_Description": "Below you will find questions where your answer could be improved. Follow the instructions before each question. When describing a situation, include the situation, what you did, and the result. Writing “OK” doesn’t help when we ask you to elaborate. At the same time, avoid overly long answers. Aim for clear and concrete descriptions, like you would in a face-to-face interview.",
            "OkMatch_NoQuestions_Description": "Your answers were solid, but this role may be competitive. This means even good answers can land in the middle of the pack.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Next time, aim for clarity and impact. Lead with the result, add one real example, and keep it concise, typically 3 to 6 sentences. Be specific about what you did, how you did it, and what changed because of it.",
            "GotPotential_Questions_Description": "Even if you seem like a strong match for this type of job, some answers can still be strengthened. If we identified any, you will find them below. Follow the instructions before each question. When describing a situation, include the situation, what you did, and the result. Writing “OK” doesn’t help when we ask you to elaborate. At the same time, avoid overly long answers. Aim for clear and concrete descriptions, like you would in a face-to-face interview.",
            "GotPotential_NoQuestions_Description": "We didn’t find any answers that need major improvement regarding professional competencies and motivations. You appear to have answered well on those topics.",
            "NotClearMatch_Questions_Description": "Below you will find questions where your answer could be improved. Follow the instructions before each question. When describing a situation, include the situation, what you did, and the result. Writing “OK” doesn’t help when we ask you to elaborate. At the same time, avoid overly long answers. Aim for clear and concrete descriptions, like you would in a face-to-face interview.",
            "NotClearMatch_NoQuestions_Description": "We didn’t find a single “bad” answer. It is more about overall alignment with what this role needs. If the competition is strong, small gaps can matter.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "For your next interview, focus on being concrete. Choose one example per question, explain your actions, and share the outcome. Short and specific usually beats long and general.",
            "Alert_WantMoreAdvice": "Want more advice on how to perform well at a Hubert interview?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Explore our general advice article"
        },
        "SimilarOffers": {
            "Title": "Similar offers"
        },
        "HowHubertScoresInterviews": {
            "Title": "How does Hubert assess interviews?",
            "Description": "Below is a short description of how Hubert assesses interview answers. We have also added a section called Recruitment process to explain what the next steps look like after the Hubert interview.",
            "Tabs_PossibleOutcomes": "Possible outcomes",
            "Tabs_RecruitmentProcess": "Recruitment process",
            "AssessedMatch_Title": "Assessed match",
            "AssessedMatch_Description": "Hubert assesses how your answers come across overall compared with what recruiters typically look for in this role. Together with the role requirements, you will see one of the outcomes below.",
            "AssessedMatch_DescriptionSecondary": "Hubert’s assessment is advisory. The recruiter makes the final decision, and other factors, like the number of candidates, can also affect the outcome.",
            "GreatMatch_Title": "Strong match",
            "GreatMatch_Description": "Your answers aligned well with what recruiters typically look for in this role, and you meet the job requirements. Excellent work. The recruiter will review all candidates and decide next steps.",
            "GotPotential_Title": "Strong potential, missing a requirement",
            "GotPotential_Description": "Your answers indicate strong potential for this type of role. However, based on this interview, you may not meet one or more required qualifications for this specific job. This can affect next steps, depending on the recruiter’s needs and the overall candidate pool.",
            "OkMatch_Title": "Qualified, add more impact",
            "OkMatch_Description": "You meet the job requirements. To stand out, your answers may need more clarity and specificity compared with what recruiters typically see for this role. Use the feedback in your interview to strengthen your examples and outcomes for the future.",
            "NotClearMatch_Title": "May not be the right fit, yet",
            "NotClearMatch_Description": "Based on this interview, your answers may be less aligned with what the recruiter is looking for in this role, and you may not meet one or more requirements. Review your answers to see where you can add clarity, examples, and outcomes.",
            "ProfessionalExperiences_Title": "Professional experiences, motivations, and competencies",
            "ProfessionalExperiences_Description": "These are questions about your previous experiences, your motivation for the job, and the competencies relevant for the role. Recruiters decide which questions are used in the interview for the specific job.",
            "GreatResults_Title": "Strong answers",
            "GreatResults_Description": "Your answers indicate you are a good fit for this type of role and communicated clearly. If any question could be improved, you will see it highlighted in your interview.",
            "NotQualified_Title": "Room to improve",
            "NotQualified_Description": "Your answers may have been less specific or outcome-focused than the recruiter expects for this role. Look for highlighted places where adding a concrete example, actions you took, or a clear result can strengthen your answers.",
            "QualifyingRequirements_Title": "Basic or qualifying requirements for this specific job",
            "QualifyingRequirements_Description": "These are questions the recruiter has set as qualifying requirements for the job. For example a required certificate, a driving license, or a certain level of relevant experience.",
            "MeetingRequirements_Title": "Meeting requirements",
            "MeetingRequirements_Description": "Your answers indicate that you meet the qualifying requirements that the recruiter set for this job. This is a good foundation.",
            "NotAllExpectationsMet_Title": "One or more requirements missing",
            "NotAllExpectationsMet_Description": "Based on your answers, you may not meet one or more of the qualifying requirements for this specific job, such as certificates, licenses, education level, or years of experience.",
            "RecruitmentProcess_Title": "Recruitment process",
            "RecruitmentProcess_Description": "Hubert is typically used as the first step in a recruitment process with many candidates. It makes it possible for everyone to complete an interview and share more about themselves in their own words. Since the interview questions are the same for all candidates applying for the same job, the process is more consistent. Hubert also does not use information like age, gender, ethnicity, religion, or appearance, which helps reduce the risk of unconscious bias.",
            "EventOne_Title": "You are interviewed by Hubert",
            "EventOne_Description": "You take the interview with Hubert when and where it suits you best. There are no time restrictions, and you can take a break at any time and continue where you left off.",
            "EventTwo_Title": "Your interview is assessed",
            "EventTwo_Description": "Hubert assesses your answers using modern technology. As soon as the assessment is completed, the results are visible to you here in My Hubert and to the recruiter in their job application system.",
            "EventThree_Title": "Recruiter selects candidates for next steps",
            "EventThree_Description": "In their job application system, recruiters can see when a new Hubert interview result is available. They can then review your answers and Hubert’s assessment. Based on Hubert’s advisory assessment and their own judgment, recruiters decide whether you will be invited to the next step. This might be a phone call, a test, or a final interview. In some cases, recruiters may wait before taking next steps. If other candidates are a better match, your application may be declined.",
            "ButtonText_Close": "Close"
        }
    },
    "MyProfile": {
        "Title": "My profile",
        "MyDetails": {
            "Title": "My details",
            "Label_FirstName": "First name",
            "Label_LastName": "Last name",
            "Label_Email": "Email",
            "Label_PhoneNumber": "Phone number",
            "ButtonText_UpdateDetails": "Update details",
            "Error_FirstName_Required": "First name is required.",
            "Error_LastName_Required": "Last name is required.",
            "Error_Email_Required": "Email is required.",
            "Error_Email_Invalid": "Enter a valid email.",
            "Error_PhoneNumber_Invalid": "Phone number is not valid.",
            "Success_Details_Updated": "Profile updated."
        },
        "ChangePassword": {
            "Title": "Change password",
            "Set_Password_Title": "Create password",
            "Label_CurrentPassword": "Current password",
            "Label_NewPassword": "New password",
            "Label_RepeatNewPassword": "Repeat new password",
            "Alert_SignInAgain": "Please sign in again to set your password.",
            "ButtonText_UpdatePassword": "Update password",
            "ButtonText_SetPassword": "Set password",
            "ButtonText_SignInAgain": "Sign in again",
            "Error_CurrentPassword_Required": "Current password is required.",
            "Error_CurrentPassword_DoesntMatch": "Password doesn't match current password.",
            "Error_NewPassword_Required": "New password is required.",
            "Error_NewPassword_6_Characters": "Your new password must be at least 6 characters long.",
            "Error_RepeatNewPassword_Required": "Repeated new password is required.",
            "Error_RepeatNewPassword_DoesntMatch": "Password doesn't match new password.",
            "Success_Password_Changed": "Password updated.",
            "Error_Invalid_CurrentPassword": "Invalid current password."
        },
        "NotificationPreferences": {
            "Title": "Notification preferences",
            "Label_ReceiveUpdatesToggle": "I want to receive Hubert updates.",
            "Label_ReceiveUpdatesToggleHelpText": "You will get career guides, interview tips, and more."
        },
        "AccountRemoval": {
            "Title": "Account removal",
            "ButtonText_RemoveMyAccount": "Remove my account"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Hello",
        "Subtitle": "You are about to start your job interview.",
        "TipBox_Title": "Here are a few tips to help you succeed.",
        "TipBox_Tip1": "Do the interview in a calm place where you can concentrate and write comfortably.",
        "TipBox_Tip2": "Answer on a computer with a keyboard (unless you are comfortable writing extensively on your mobile).",
        "TipBox_Tip3": "Be as specific and detailed in your answers as possible. Hubert and recruiters want to get to know you well.",
        "TipBox_Tip4": "Take the time you need. There are no time restrictions.",
        "TipBox_Tip5": "You can take a break at any time and continue where you left off.",
        "TipBox_Tip6": "Be yourself and approach the Hubert interview with the same commitment as a real-person interview.",
        "CheckAdviceArticle_Text1": "If you want more tips on how to succeed at the interview, check out this",
        "CheckAdviceArticle_Text2": "article",
        "CheckAdviceArticle_Text3": "with great advice.",
        "ReadyToGetStarted": "Are you ready to get started?",
        "ORSeparator_Text": "Or",
        "ButtonText_StartInterviewNow": "Start interview now",
        "ButtonText_SetReminder": "I'm not ready, set a reminder",
        "PrivacyPolicyText": "By pressing start interview you agree to the",
        "PrivacyPolicyLink": " Privacy Policy and Terms & Conditions"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Great work!",
        "CompletedAlert_Subtitle": "You finished your interview.",
        "CompletedAlert_Description": "Recruiters will review all applications and provide feedback via email or phone as soon as they have an update.",
        "InterviewNotCompleted": "This interview is not completed."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Help center",
            "Subtitle": "Find answers to the most commonly asked questions about Hubert.",
            "Label_Search": "search frequently asked questions",
            "ButtonText_Search": "Search"
        },
        "FAQSection": {
            "Tabs_All": "All",
            "Tabs_AboutHubertInterview": "About Hubert interview",
            "Tabs_TechnicalSupport": "Technical support"
        },
        "StillHaveQuestion": {
            "Title": "Still have a question?",
            "Description": "We are happy to help.",
            "DropUsAEmail": "Email us at hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Can I conduct my interview via phone call instead?",
                    "a": "Hubert only operates by chat at the moment. If you have a medical condition that prevents you from taking the interview, please reach out directly to the hiring company. Hubert is only responsible for the chat interview."
                },
                {
                    "q": "Can I take the interview in another language?",
                    "a": "For some interviews, there is an option to select a language at the start. If this option is missing, understanding the language in the interview is most likely a requirement for the position. For further questions, please reach out to the recruiting company."
                },
                {
                    "q": "Will I be penalized for giving short responses?",
                    "a": "No, you will not, as long as you respond to the questions appropriately. There is no minimum length for an answer, but details often help."
                },
                {
                    "q": "Can I reuse my responses from another interview with Hubert?",
                    "a": "Yes, you can re-use previous responses if you have logged into My Hubert and apply for a similar role."
                },
                {
                    "q": "Will a human read my interview?",
                    "a": "Yes, our customers are asked to manually check interviews."
                },
                {
                    "q": "I have done the interview, what happens now?",
                    "a": "After the interview is done, the results are sent to the recruiter in their job application system. Recruiters can then review your answers and Hubert's assessment. Based on Hubert's advisory assessment and their own judgment, recruiters decide if you will be invited to the next step. This might be a telephone call, a test, or a final interview."
                },
                {
                    "q": "I have a question about next steps in the process, who should I contact?",
                    "a": "Please reach out to the company where you applied for the job."
                },
                {
                    "q": "How do you ensure you don't introduce bias in the recruiting process?",
                    "a": "Reducing bias is critical to us. As a machine, Hubert is more consistent in assessment than a human can be. Our models are trained using many expert reviewers with diverse backgrounds. Additionally, Hubert does not use information like gender, age, ethnicity, religion, or appearance, which are common sources of bias in traditional manual job interviews."
                },
                {
                    "q": "Can I be interviewed by a human instead of Hubert?",
                    "a": "Please reach out to the company where you applied for the job to inquire about this."
                },
                {
                    "q": "Is Hubert a human being?",
                    "a": "No, Hubert is a computer-based interviewing and analysis system."
                },
                {
                    "q": "Can I change my responses later?",
                    "a": "No, just as in a real interview, you cannot re-do your answers once submitted."
                },
                {
                    "q": "How do I succeed in the Hubert interview?",
                    "a": "Read the questions carefully before responding. Follow the instructions. Give real examples from your experience and be honest."
                },
                {
                    "q": "I need a job, who should I contact?",
                    "a": "Please reach out to the company where you applied."
                },
                {
                    "q": "I have done the interview but haven't heard anything. What should I do?",
                    "a": "Recruiters decide next steps based on Hubert's assessment and their own judgment. This might be a phone call, a test, or a final interview. If other candidates are a better match, they may reject your application. You may want to contact the recruiter to check the progress of your application."
                },
                {
                    "q": "I have a lot of experience, but I did not get the job. Why?",
                    "a": "Competition for jobs can be high, with many qualified candidates. If your application was rejected, you may want to contact the company to ask why. You can also check My Hubert for feedback based on your interview answers and view other job options."
                },
                {
                    "q": "How long does the interview take?",
                    "a": "It depends on the number of questions set by the recruiter. Expect between 10 and 25 minutes. Do not rush. You can take a break and continue later if needed."
                },
                {
                    "q": "Where can I read about how my data is handled?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Why can't I see my previous Hubert interviews?",
                    "a": "Ensure you used the same email address to apply for the job as you used to log in to My Hubert. This also applies when using Google login; the Google email must match the application email. Try creating an account with the email address you used to apply for the job."
                },
                {
                    "q": "Why didn't I receive an email for my interview?",
                    "a": "Check your spam folder. You can also add hubert@hubert.ai to your contacts. Alternatively, create a My Hubert account (using the application email) to find the interview link there."
                },
                {
                    "q": "I can't find the link to my interview in my email.",
                    "a": "Check your spam folder. Alternatively, create a My Hubert account (using the application email) and go to 'My Interviews' to find the link."
                },
                {
                    "q": "Does the interview work on mobile devices?",
                    "a": "Yes, it does. However, if you are more comfortable typing on a computer, we recommend using one."
                },
                {
                    "q": "The interview is not working, what should I do?",
                    "a": "We are sorry to hear that. Please email us at hubert@hubert.ai, and we will assist you."
                },
                {
                    "q": "I want to delete my entire account on My Hubert, what should I do?",
                    "a": "Send us an email at hubert@hubert.ai, and we will assist you."
                },
                {
                    "q": "The interview was interrupted, how can I return?",
                    "a": "Click the link in the email invitation to return to where you left off, or log in to My Hubert and select the interview in 'My Interviews'."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Learn with Hubert",
            "Subtitle": "Find out how to increase your chances in the recruitment process and perform better at work.",
            "Label_Search": "search interview and career guides",
            "ButtonText_Search": "Search"
        },
        "TabSelector": {
            "MyFeed": "My feed",
            "InterviewGuides": "Interview guides",
            "CareerGuides": "Career guides"
        },
        "NewestOnTheFeed": "Newest on the feed",
        "PickedForMe": "Latest articles",
        "InterviewGuides": "Interview guides",
        "CareerGuides": "Career guides"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Back to all articles"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Reset your password",
        "ResetLinkAlert_Subtitle": "Click the password reset link sent to your email to set a new password and sign in to your account.",
        "PasswordNotSetAlert_Message": "Password not set, please sign in using ",
        "ResetYourPassword": {
            "MainTitle": "View your Hubert interview results",
            "Subtitle": "Sign in to see results, get feedback, read advice, and much more.",
            "FormSectionTitle": "Reset your password",
            "Label_NewPassword": "New password",
            "Label_ConfirmNewPassword": "Confirm new password",
            "Error_NewPassword_Required": "Please enter a new password.",
            "Error_Password_6_Characters": "Your new password must be at least 6 characters long.",
            "Error_ConfirmNewPassword_Required": "You must confirm your new password.",
            "Error_ConfirmNewPassword_NotMatch": "Password doesn't match new password.",
            "Error_MalformedResetUrl": "Invalid security code. Please try again.",
            "Error_ResetPasswordFailed": "We had a problem resetting the password. Please try again.",
            "Error_WeakPassword": "Password must contain at least 6 characters.",
            "Error_InvalidCode_Title": "Your password reset request is expired or invalid.",
            "Error_InvalidCode_Subtitle": "Please try resetting your password again.",
            "ButtonText_SetNewPassword": "Set new password & sign in",
            "ButtonText_RememberYourPassword": "Remember your password?",
            "ButtonText_SignInInstead": "Sign in instead"
        }
    },
    "PageNotFound": {
        "Title": "Page not found",
        "Description": "We can't seem to find the page you're looking for.",
        "ButtonText_GoToDashboard": "Go to Dashboard",
        "ButtonText_GoToLogin": "Go to Login"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Re-usage of answers is not yet available for this interview. We expect this feature to be available soon, but you can still take the interview now.",
        "DescriptionLine2": "Please proceed to the interview by clicking the button below.",
        "ButtonText_TakeMeToTheInterview": "Take me to the interview"
    },
    "UnsubscribeFromEmails": {
        "Title": "Are you sure?",
        "Subtitle": "You will stop receiving emails from us about this job:",
        "SelectTheReason": "Please select a reason from the options below.",
        "ReasonText1": "I have found another job.",
        "ReasonText2": "I am no longer interested in this job.",
        "ReasonText3": "Other",
        "ButtonText_Unsubscribe": "Unsubscribe from this job",
        "Placeholder_YourReason": "Your reason",
        "Success_Title": "You successfully unsubscribed from emails about this job.",
        "Loading": "Loading...",
        "Error_YourReason_Required": "Please enter a reason.",
        "Error_ServerIssue": "Unsubscription failed due to server error."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Try again"
    },
    "Outreach": {
        "CandidateNotFound": "Candidate not found",
        "CandidateNotFoundDesc": "We couldn't find the interview details you're looking for.",
        "InterviewEnded": "Interview ended",
        "InterviewEndedDesc1": "This interview session has ended or is no longer available.",
        "InterviewEndedDesc2": "Thanks for your time. If you have any questions, please contact the recruitment team.",
        "ReadyTitle": "Ready for your interview, {{firstName}}?",
        "InvitationDesc": "Hubert, on behalf of {{companyName}}, is inviting you to a chat-based interview. It takes around 1–2 minutes to complete.",
        "Button_StartChat": "Start chat interview",
        "CancelNotice": "Starting here will cancel the scheduled call for this role.",
        "PreferNotToContinue": "Not looking to continue?",
        "DeclineLabel": "I'm not interested in this role. Please don't call or message me again about this position.",
        "Button_ConfirmAndDecline": "Confirm and decline",
        "Processing": "Processing...",
        "Toast_DeclineSuccess": "Interview declined.",
        "Toast_CancelVoiceInfo": "Call cancelled. Feature coming soon.",
        "Toast_CancelError": "Couldn't cancel the interview. Please try again.",
        "Footer_WithdrawConsent": "You can withdraw your consent at any time. Learn more in ",
        "Footer_PrivacyPolicySuffix": "'s privacy policy",
        "Footer_And": " and ",
        "Footer_HubertPrivacyLink": "Hubert's Privacy Policy and Terms & Conditions",
        "Chat_InterviewWith": "Interview with {{companyName}}",
        "Chat_StatusConnected": "Connected",
        "Chat_StatusError": "Error",
        "Chat_StatusDisconnected": "Disconnected",
        "Chat_StatusConnecting": "Connecting...",
        "Chat_ReadyToStart": "Ready to start the interview?",
        "Chat_ButtonStart": "Start interview",
        "Chat_SayHello": "Say hello to start the conversation.",
        "Chat_EmptyState": "Send a message to start the interview.",
        "Chat_SelectLanguage": "Choose your preferred language",
        "Chat_Placeholder": "Type your message...",
        "Chat_ButtonSend": "Send",
        "Chat_ButtonBack": "Back",
        "LoadingCandidateDetails": "Loading candidate details...",
        "FetchingCandidateDetails": "Fetching candidate details...",
        "Chat_StatusReady": "Waiting to connect...",
        "Chat_ForbiddenError": "This chat interview is no longer available.",
        "Chat_GeneralError": "Failed to start the chat. Please try again later.",
        "Chat_SelectUiLanguage": "UI Language",
        "Chat_InterviewTitle": "Job Interview"
    }
}
